export const RESET_DASHBOARDS_STATE = 'RESET_DASHBOARDS_STATE';
export const RESET_APPLIED_FILTERS = 'RESET_APPLIED_FILTERS';
export const RESET_PREVIEW_WIDGET = 'RESET_PREVIEW_WIDGET';
